export const update = {
  updateSuccessfully: 'Update detergent successfully!',
}
